export default {
  SET_ONE_FLAT(state, data) {
    state.single_flat = data
  },
  SET_FLATS(state, data) {
    state.flats = data
  },
  SET_FLATS_PLANNINGS(state, data) {
    state.flat_plannings = data
  },
  SET_FLAT_CHARACTERISTIC(state, data) {
    state.characteristic = data
  },
  SET_FLAT_PERCENTAGES(state, data) {
    state.flatPercentages = data
  },
}